import _ from 'lodash'
import API from '../utilities/API'
const STATUSES = {
  0: 'DEACTIVATED',
  1: 'ACTIVE',
  2: 'INVITED'
}
class User {

  _retrieveRole (roleId, roles) {
    let finalRole = {}
    _.forIn(roles, role => {
      if (roleId === role.userRoleID) {
        finalRole = role
      }
    })
    return finalRole
  }

  _retrieveRoleUsingCode (roleCode, roles) {
    let finalRole = {}
    _.forIn(roles, role => {
      if (role.roleCode === roleCode) {
        finalRole = role
      }
    })
    return finalRole
  }
  _retrieveStatus (status) {
    return STATUSES[status]
  }

  activateUser ({ user }) {
    user.userActive = _.invert(STATUSES)['ACTIVE']
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'updateUser', data: user})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }

  create (data) {
    // Submit request
    return new Promise((resolve, reject) => {
      API
        .post({ url: 'saveSignUpRequest', data })
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          }
          reject(response)
        })
        .catch(response => { reject(response) })
    })
  }

  deactivateUser ({ user }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'updateUser', data: user})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }

  fetchClientUsers ({ clientCode }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({ url: 'fetchClientUsers', data: { clientCode } })
        .then(response => {
          if (response.SUCCESS) {
            // Clean up the user data
            let data = { roles: {}, users: [] }
            response.DATA.users.forEach(user => {
              data.users.push({
                name: _.capitalize(user.firstName) + ' ' + _.capitalize(user.lastName),
                ...(_.pick(user, ['emailAddress', 'userActive', 'userID'])),
                fullName: _.capitalize(user.firstName) + ' ' + _.capitalize(user.lastName),
                role: _.capitalize(this._retrieveRole(user.userRoleID, response.DATA.userRoles).roleName),
                status: _.capitalize(this._retrieveStatus(user.userActive)),
                date: user.dateCreated
              })
            })
            _.forIn(response.DATA.userRoles, (role, key) => {
              role.roleName = _.capitalize(role.roleName)
              data.roles[role.userRoleID] = role
            })
            resolve(data)
          }
          reject(response)
        })
        .catch(response => { reject(response) })
    })
  }

  inviteUser ({ user }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({ url: 'createUser', data: user })
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          }
          reject(response)
        })
        .catch(response => { reject(response) })
    })
  }

  updateUserProfile ({ user }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'updateUser', data: user})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }

  updateClient ({ client }) {
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({url: 'updateClient', data: client})
        .then(response => {
          if (response.SUCCESS) {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(response => {
          reject(response)
        })
    })
  }
}

export default new User()



// WEBPACK FOOTER //
// ./src/api/services/user.js